/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  OnDestroy
} from '@angular/core';
import { ProfileService } from '~app/app/~shared/services/profile.service';
import { LoadListener } from '@veone/ngx-utilities/rxjs';
import { Subject, takeUntil } from 'rxjs';
import { UserPreferences } from '~core/models/shared.models';

@Component({
  selector: 'security-form',
  templateUrl: './security-form.component.html',
  styleUrls: ['./security-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SecurityFormComponent implements OnInit, OnDestroy {
  private _destroy$ = new Subject<void>();
  securityPreferences$: LoadListener<UserPreferences> | undefined;

  constructor(private profileService: ProfileService) {}

  ngOnInit(): void {
    this.initSecurityPreferences();
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  initSecurityPreferences(): void {
    this.securityPreferences$ = new LoadListener(
      this.profileService.readPreference()
    );
  }

  updatePreference(
    type: 'doubleFactor' | 'watchdog' = 'doubleFactor',
    value: boolean
  ): void {
    const preferenceKey =
      type === 'doubleFactor'
        ? 'security.authentication.double_factor'
        : 'security.authentication.watchdog';
    this.profileService
      .setPreference({
        [preferenceKey]: value
      })
      .pipe(takeUntil(this._destroy$))
      .subscribe();
  }
}
